import { render } from "./Security_Logout_Dialog.vue?vue&type=template&id=21c839f8&scoped=true"
import script from "./Security_Logout_Dialog.vue?vue&type=script&lang=js"
export * from "./Security_Logout_Dialog.vue?vue&type=script&lang=js"

import "./Security_Logout_Dialog.vue?vue&type=style&index=0&id=21c839f8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c839f8"]])

export default __exports__